import React from 'react';
import { ARIA_LABELS, COMMON_TEXT } from '@/constants/labels';
import { cn } from '@/utils';
import { scoreDisplayStyles, scorecardStyles } from '../Scorecard.styles';
import { ScorecardProps } from '../types';
import { FormattedScore } from './ScorecardFormattedScore';
import { TagSkeleton } from './ScorecardTagSkeleton';

export interface VariantSimpleProps {
	ariaScoreLabel: string;
	className?: string;
	isLoading?: boolean;
	maxScore: number;
	score?: number;
	size: NonNullable<ScorecardProps['size']>;
}

export const VariantSimple: React.FC<VariantSimpleProps> = ({
	ariaScoreLabel,
	className,
	isLoading = false,
	maxScore,
	score,
	size,
}) => {
	if (isLoading) return <TagSkeleton />;

	return (
		<div
			aria-label={ARIA_LABELS.SCORE_DISPLAY}
			className={cn(scorecardStyles({ size, variant: 'simple' }), className)}
			role="region"
		>
			<div aria-label={ariaScoreLabel} className={scoreDisplayStyles({ size: 'simple' })}>
				<FormattedScore maxScore={maxScore} score={score} />
			</div>
			<div className="text-sm font-bold text-neutral-gray-700" aria-hidden="true">
				{COMMON_TEXT.SCORE}
			</div>
		</div>
	);
};

VariantSimple.displayName = 'VariantSimple';

export default VariantSimple;
